import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { navigateToHomeSection } from '../utils/navigation';

const Navbar = () => {

  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();
  const navContainerRef = useRef(null);

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'Products', href: '#products' },
    { name: 'Industries', href: '#industries' },
    { name: 'Partners', href: '#clients' },
    { name: 'About', href: '#about' },
    { name: 'News', href: '#press-news' },
    { name: 'How We Work', href: '#how-we-work' },
    { name: 'Case Studies', href: '#case-studies' }
  ];

  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {

    const handleScroll = () => {

      const sections =
        document.querySelectorAll('section[id]');

      let current = '';

      sections.forEach(section => {

        const sectionTop =
          section.offsetTop;

        if (
          window.scrollY >= sectionTop - 200
        ) {
          current =
            section.getAttribute('id');
        }

      });

      setActiveSection(current);

    };

    window.addEventListener(
      'scroll',
      handleScroll
    );

    return () =>
      window.removeEventListener(
        'scroll',
        handleScroll
      );

  }, []);

  useEffect(() => {
    const handleOutsidePointer = (event) => {
      if (
        mobileOpen &&
        navContainerRef.current &&
        !navContainerRef.current.contains(event.target)
      ) {
        setMobileOpen(false);
      }
    };

    document.addEventListener('pointerdown', handleOutsidePointer);
    return () => document.removeEventListener('pointerdown', handleOutsidePointer);
  }, [mobileOpen]);

  const handleNavClick = (e, href) => {
    e.preventDefault();

    const selector = href.startsWith('/') ? href.slice(href.indexOf('#')) : href;
    const target = document.querySelector(selector);

    if (target) {
      const navHeight = document.querySelector('.navbar').offsetHeight;
      const offsetTop = target.offsetTop - navHeight - 20;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    } else {
      // navigate to home and scroll to section
      const normalized = href.startsWith('#') ? '/'+href : href;
      navigateToHomeSection(normalized);
    }
  };

  return (

    <nav className="navbar">

      <div className="nav-container" ref={navContainerRef}>

        <Link
          to="/"
          className="nav-logo"
          aria-label="AIVION home"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img
            src="/images/icon.PNG"
            alt="AIVION"
            className="nav-logo-img"
          />
        </Link>

        <div className="nav-menu">

          <Link
            to="/"
            className={`nav-link nav-home-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={() => {
              setMobileOpen(false);
              if (location.pathname === '/') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            Home
          </Link>

          {navLinks.map(link => (

            <a
              key={link.name}
              href={link.href}
              className={`nav-link ${
                activeSection ===
                link.href.slice(1)
                  ? 'active'
                  : ''
              }`}
              onClick={(e) => {
                setMobileOpen(false);
                handleNavClick(
                  e,
                  link.href
                )
              }}
            >
              {link.name}
            </a>

          ))}

        </div>

        <button
          className="contact-btn"
          onClick={(e) => {
            setMobileOpen(false);
            handleNavClick(
              e,
              '#contact'
            )
          }}
        >
          CONTACT US
        </button>

        <button
          className={`burger ${mobileOpen ? 'open' : ''}`}
          aria-label="Toggle menu"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span />
          <span />
          <span />
        </button>

        {mobileOpen && (
          <div className="mobile-menu">
            <Link
              to="/"
              className={`mobile-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={() => {
                setMobileOpen(false);
                if (location.pathname === '/') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
            >
              Home
            </Link>

            {navLinks.map(link => (
              <a
                key={link.name}
                href={link.href}
                className={`mobile-link ${
                  activeSection === link.href.slice(1)
                    ? 'active'
                    : ''
                }`}
                onClick={(e) => {
                  setMobileOpen(false);
                  handleNavClick(e, link.href);
                }}
              >
                {link.name}
              </a>
            ))}

            <button
              className="mobile-contact"
              onClick={(e) => {
                setMobileOpen(false);
                handleNavClick(e, '#contact');
              }}
            >
              CONTACT US
            </button>
          </div>
        )}

      </div>

    </nav>

  );

};

export default Navbar;
